import { useTranslation } from "react-i18next";
import {
  CheckOutlined,
  CloseOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  Button,
  Collapse,
  DatePicker,
  Form,
  FormInstance,
  message,
  Modal,
  Radio,
  RadioChangeEvent,
  Select,
  Typography,
} from "antd";
import { get, isEmpty } from "lodash";
import { useEffect, useState } from "react";
import "./styles.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDetailQuestionBank,
  getDetailQuestionBankMinistry,
  getQuestionBankDetailHistory,
  getQuestionDetail,
  getQuestionDetailHistory,
  putApproveQuestionBank,
} from "../../../../service/question-bank";
import { dataInfo } from "../../../../pages/detail/constants/dataInfo";
import TextArea from "antd/es/input/TextArea";
import moment, { Moment } from "moment";
import { LocationState } from "../..";
import dayjs, { Dayjs } from "dayjs";
import { viLocale } from "../../../../utils/pickerType";

const { Panel } = Collapse;

export type UpdateSettingsProps = {
  handelChangeForm?: (val: any, name: string, cb?: any) => void;
  handelUpdateSettings?: (val: any, name: string, cb?: any) => void;
  form?: FormInstance;
  mode?: string;
};

type QuestionBankDetail = {
  id: number;
  unitId: number;
  code: string;
  title: string;
  topics: string;
  numberQuestion: number;
  description: string | null;
  tags: string;
  numberOfUse: number;
  authors: string | string[];
  access: string;
  createdBy: string | null;
  publishingUnit: string | null;
  hierarchy: string | null;
  moocQuestionBankId: number;
  moocCourseUnitId: number;
  typeProduction: number | string;
  productionUnitId: number | null;
  productionUnitName: string | null;
  productUnitName: string | null;
  typeApproved: string;
  action: string;
  contentApprove: string;
  approvedSendDate: string;
  approvedDate: string;
  question: string;
  status: boolean;
  approvedBy: number;
  createdDate: string;
  approveByName: string;
  author: string | string[] | any[]; // Array, you may specify the exact type if needed
  topic: any[]; // Array, you may specify the exact type if needed
  approvedDescription: string;
  publishStatus: number;
  publicDate: string;
  scheduleType: number;
};

type Answer = {
  uuid: string;
  point: number;
  isTrue: boolean;
  content: string;
  fileName: string | null;
  filePath: string | null;
  response: string | null;
  orderNumber: number;
  isDisplayContent: boolean | null;
};

type QuestionDetail = {
  id: number;
  moocQuestionBankId: number;
  moocCourseUnitId: number | null;
  moocCourseBlockQuizId: number;
  typeQuestion: number;
  type: number;
  action: string;
  level: number;
  question: string;
  code: string;
  title: string | null;
  createdDate: string;
  typeProduction: number | string;
  productionUnitId: string;
  productionUnitName: string;
  productionUnit: string;
  typeApproved: string;
  createdBy?: string;
  approvedSendDate: string; // ISO date string
  approvedDate: string | null; // ISO date string
  status: boolean;
  approvedBy: string | null;
  approveByName: string | null;
  authors: string;
  topics: string;
  access: string;
  numberOfUse: number | null;
  description: string;
  tags: string;
  approvedDescription: string | null;
  contentApprove: string | null;
  publishStatus: number;
  publicDate: string | null; // ISO date string
  scheduleType: number;
};

const SettingExam = (props: UpdateSettingsProps) => {
  const { t } = useTranslation();
  const [dataDetail, setDataDetail] = useState<QuestionBankDetail>();
  const [questionDetail, setQuestionDetail] = useState<QuestionDetail>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const unitId = searchParams.get("id");

  const getPublishStatus = (status: number): string => {
    switch (status) {
      case 0:
        return t("Bản nháp", "Bản nháp");
      case 1:
        return t("Chờ QTCS duyệt", "Chờ QTCS duyệt");
      case 2:
        return t("Chờ Cấp bộ duyệt", "Chờ Cấp bộ duyệt");
      case 3:
        return t("QTCS không duyệt", "QTCS không duyệt");
      case 4:
        return t("Cấp Bộ không duyệt", "Cấp Bộ không duyệt");
      case 5:
        return t("Đã lên lịch", "Đã lên lịch");
      case 6:
        return t("Đã xuất bản", "Đã xuất bản");
      case 7:
        return t("Chưa xuất bản", "Chưa xuất bản");
      case 8:
        return t("Đề xuất chỉnh sửa", "Đề xuất chỉnh sửa");
      default:
        return "";
    }
  };

  const [approveRadio, setApproveRadio] = useState(1);
  const [comment, setComment] = useState("");
  const [publishMode, setPublishMode] = useState(1);
  const [selectDate, setSelectDate] = useState<Dayjs | null>(null);
  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const { state } = location as { state: LocationState };
  const [handlePressSave, setHandlePressSave] = useState(false);

  const mode = state.mode;
  const [showAllAuthors, setShowAllAuthors] = useState(false);

  const onChangeRadio = (e: RadioChangeEvent) => {
    setApproveRadio(e.target.value);
  };
  const navigate = useNavigate();
  const navigateBack = () => {
    navigate(state.backUrl);
  };

  const handleShowMore = () => {
    setShowAllAuthors(!showAllAuthors);
  };

  const renderAuthors = (authors: string[] | string | number[]) => {
    if (typeof authors === "string") {
      // If only one author (a single string)
      return <span>{authors}</span>;
    } else if (Array.isArray(authors)) {
      // If multiple authors (array of strings)
      if (authors.length <= 2) {
        return <span>{authors[0]}</span>;
      } else {
        return (
          <>
            {/* Display the first author and a "More" button if there are multiple authors */}
            <span>{authors[0]}</span>
            <span>{authors[1]}</span>
            {!showAllAuthors && authors.length > 2 && (
              <button
                style={{
                  color: "blue",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  marginLeft: 8,
                }}
                onClick={handleShowMore}
              >
                {t("Xem thêm", "Xem thêm")}
              </button>
            )}
            {showAllAuthors && (
              <span>
                {authors
                  .slice(1)
                  .map((author: string | number, index: number) => (
                    <span key={index}> , {author}</span>
                  ))}
              </span>
            )}
          </>
        );
      }
    }
  };

  const renderAccess = (access: string | string[]) => {
    if (typeof access === "string") {
      return <span>{access}</span>;
    } else if (Array.isArray(access)) {
      if (access.length <= 2) {
        return <span>{access[0]}</span>;
      } else {
        return (
          <>
            <span>{access[0]}</span>
            <span>{access[1]}</span>
            {!showAllAuthors && access.length > 2 && (
              <button
                style={{
                  color: "blue",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  marginLeft: 8,
                }}
                onClick={handleShowMore}
              >
                {t("Xem thêm", "Xem thêm")}
              </button>
            )}
            {showAllAuthors && (
              <span>
                {access.slice(1).map((item: string | number, index: number) => (
                  <span key={index}> , {item}</span>
                ))}
              </span>
            )}
          </>
        );
      }
    }
  };

  const renderType = (value: string) => {
    switch (Number(value)) {
      case 1:
        return t("Nhiều lựa chọn văn bản", "Nhiều lựa chọn văn bản");
      case 2:
        return t("Nhiều lựa chọn ảnh", "Nhiều lựa chọn ảnh");
      case 3:
        return t("Nhiều lựa chọn video", "Nhiều lựa chọn video");
      case 4:
        return t("Lựa chọn đúng sai", "Lựa chọn đúng sai");
      case 5:
        return t("Danh sách", "Danh sách");
      case 6:
        return t("Nhiều đáp án văn bản", "Nhiều đáp án văn bản");
      case 7:
        return t("Nhiều đáp án hình ảnh", "Nhiều đáp án hình ảnh");
      case 9:
        return t("Câu trả lời ngắn", "Câu trả lời ngắn");
      case 10:
        return t("Điền vào chỗ trống", "Điền vào chỗ trống");
      case 11:
        return t("Trình soạn thảo", "Trình soạn thảo");
      case 12:
        return t("Kết nối", "Kết nối");
      case 13:
        return t("Sắp xếp", "Sắp xếp");
      case 14:
        return t("Ghi âm", "Ghi âm");
      case 15:
        return t("Ghi hình", "Ghi hình");
      case 16:
        return t("Đính kèm", "Đính kèm");
      default:
        return t("Bản nháp", "Bản nháp");
    }
  };

  const handleGetDetail = async () => {
    try {
      await getDetailQuestionBank(Number(unitId)).then((result) => {
        if (result.data) {
          setDataDetail(result.data.data);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDetailMinistryContent = async () => {
    try {
      await getDetailQuestionBankMinistry(Number(unitId)).then((result) => {
        if (result.data) {
          setDataDetail(result.data.data);
          if (result.data.data.publicDate) {
            const parsedDateTime = dayjs(result.data.data?.publicDate).utc();
            setSelectDate(parsedDateTime);
          }
          setPublishMode(result.data.data?.scheduleType);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDetailUniversityContent = async () => {
    try {
      await getDetailQuestionBankMinistry(Number(unitId)).then((result) => {
        if (result.data) {
          setDataDetail(result.data.data);
          if (result.data.data.publicDate) {
            const parsedDateTime = dayjs(result.data.data?.publicDate).utc();
            setSelectDate(parsedDateTime);
          }
          setPublishMode(result.data.data?.scheduleType);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDetailQuestion = async () => {
    try {
      await getDetailQuestionBankMinistry(Number(unitId)).then((result) => {
        if (result.data) {
          setQuestionDetail(result.data.data);
          // handleGetQuizBank(result.data.data.moocQuestionBankId)
          if (result.data.data.publicDate) {
            const parsedDateTime = dayjs(result.data.data?.publicDate).utc();
            setSelectDate(parsedDateTime);
          }
          setPublishMode(result.data.data?.scheduleType);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleGetDetailHistoryQuestion = async () => {
    try {
      await getQuestionDetailHistory(Number(unitId)).then((result) => {
        if (result.data) {
          setQuestionDetail(result.data.data);
          if (result.data.data.publicDate) {
            const parsedDateTime = dayjs(result.data.data?.publicDate).utc();
            setSelectDate(parsedDateTime);
          }
          setPublishMode(result.data.data?.scheduleType);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDetailHistoryQuestionBank = async () => {
    try {
      await getQuestionBankDetailHistory(Number(unitId)).then((result) => {
        if (result.data) {
          setDataDetail(result.data.data);
          if (result.data.data.publicDate) {
            const parsedDateTime = dayjs(result.data.data?.publicDate).utc();
            setSelectDate(parsedDateTime);
          }
          setPublishMode(result.data.data?.scheduleType);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetQuizBank = async (id: string) => {
    try {
      await getQuestionDetail(id).then((result) => {
        // setQuestionInfo(result.data.data)
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (mode === "0" || mode === "4") handleGetDetail();
    else if (mode === "1") handleGetDetailMinistryContent();
    else if (mode === "2") handleGetDetailUniversityContent();
    // call question API here
    else if (mode === "5") handleGetDetailQuestion();
    else if (mode === "6") handleGetDetailQuestion();
    else if (state?.mode === "7") handleGetDetailHistoryQuestion();
    else if (state?.mode === "8") handleGetDetailHistoryQuestionBank();
  }, []);

  const [flag, setFlag] = useState<boolean>(true);
  const toggleFlag = () => {
    setFlag((prev) => !prev);
  };
  // const [mode, setMode] = useState("1");

  const handlePopupConfirm = () => {
    if (publishMode === 3 && !selectDate) {
      setHandlePressSave(true);
    } else {
      setIsVisibleConfirm(true);
    }
  };

  const handleConfirm = async () => {
    const params = [
      {
        id: unitId,
        status: approveRadio,
        description: comment,
        publishDate: selectDate?.utc().toISOString(),
        scheduleType: publishMode,
      },
    ];
    try {
      await putApproveQuestionBank(params).then((result) => {
        if (result.data) {
          message.success(t("Lưu nội dung kiểm duyệt thành công", "Lưu nội dung kiểm duyệt thành công"));
          setIsVisibleConfirm(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getDifficultyLabel = (level: number): string => {
    switch (level) {
      case 0:
        return t("Dễ", "Dễ");
      case 1:
        return t("Trung bình", "Trung bình");
      case 2:
        return t("Nâng cao", "Nâng cao");
      default:
        return "";
    }
  };

  const renderTypeProduction = (type: number) => {
    switch (type) {
      case 1:
        return <>{t("Cấp giảng viên", "Cấp giảng viên")}</>
      case 2:
        return <>{t("Cấp trường", "Cấp trường")}</>
      case 3:
        return <>{t("Cấp bộ", "Cấp bộ")}</>
      default:
        break;
    }
  }

  const detailExam = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Mã đề:", "Mã đề:")}</div>
          {dataDetail?.code ? (
            <div>{dataDetail?.code || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Tiêu đề:", "Tiêu đề:")}</div>
          {dataDetail?.title ? (
            <div>{dataDetail?.title || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Chủ đề:", "Chủ đề:")}</div>
          {dataDetail?.topics ? (
            <div>{dataDetail?.topics || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Số câu hỏi:", "Số câu hỏi:")}</div>
          {dataDetail?.numberQuestion !== undefined &&
            dataDetail?.numberQuestion !== null ? (
            <div>{dataDetail?.numberQuestion}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Mô tả:", "Mô tả:")}</div>
          {dataDetail?.description ? (
            <div>{dataDetail?.description || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Nhãn:", "Nhãn:")}</div>
          {dataDetail?.tags ? (
            <div>{dataDetail?.tags || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Lượt dùng:", "Lượt dùng:")}</div>
          {dataDetail?.numberOfUse !== undefined &&
            dataDetail?.numberOfUse !== null ? (
            <div>{dataDetail?.numberOfUse}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Phân cấp:", "Phân cấp:")}</div>
          {dataDetail?.typeProduction !== undefined &&
            dataDetail?.typeProduction !== null ? (
            <div>{renderTypeProduction(Number(dataDetail?.typeProduction))}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Tác giả:", "Tác giả:")}</div>
          <div>{renderAuthors(dataDetail?.authors || "")}</div>
        </div>
        <div className="info-item">
          <div className="info-title">{t("Đơn vị xuất bản:", "Đơn vị xuất bản:")}</div>
          {dataDetail?.productionUnitName || dataDetail?.productUnitName ? (
            <div>
              {dataDetail?.productionUnitName || dataDetail?.productUnitName}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Quyền truy cập:", "Quyền truy cập:")}</div>
          {dataDetail?.access ? (
            <div>{t(dataDetail?.access, dataDetail?.access)}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        {mode === "0" ? (
          <div className="info-item">
            <div className="info-title">{t("Ngày xuất bản:", "Ngày xuất bản:")}</div>
            {dataDetail?.publicDate ? (
              <div>
                {dayjs(dataDetail?.publicDate)
                  .utc()
                  .format("DD/MM/YYYY HH:mm:ss")}
              </div>
            ) : (
              <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const detailQuestion = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Mã câu hỏi:", "Mã câu hỏi:")}</div>
          {questionDetail?.code ? (
            <div>{questionDetail?.code || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Độ khó:", "Độ khó:")}</div>
          {questionDetail?.level !== undefined ? (
            <div>{getDifficultyLabel(questionDetail?.level)}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Loại câu hỏi:", "Loại câu hỏi:")}</div>
          {questionDetail?.typeQuestion || questionDetail?.type ? (
            <div>
              {renderType(
                `${questionDetail?.typeQuestion || questionDetail?.type}`
              )}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Nhãn:", "Nhãn:")}</div>
          {questionDetail?.tags ? (
            <div>{questionDetail?.tags || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Lượt dùng:", "Lượt dùng:")}</div>
          {questionDetail?.numberOfUse !== undefined &&
            questionDetail?.numberOfUse !== null ? (
            <div>{questionDetail?.numberOfUse || ""}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Phân cấp:", "Phân cấp:")}</div>
          {questionDetail?.typeProduction !== undefined &&
            questionDetail?.typeProduction !== null ? (
            <div>{renderTypeProduction(Number(questionDetail?.typeProduction))}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Tác giả:", "Tác giả:")}</div>
          {questionDetail?.authors ? (
            <div>{renderAuthors(questionDetail?.authors || "")}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Đơn vị xuất bản:", "Đơn vị xuất bản:")}</div>
          {questionDetail?.productionUnitName ||
            questionDetail?.productionUnit ? (
            <div>
              {questionDetail.productionUnitName ||
                questionDetail?.productionUnit}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Quyền truy cập:", "Quyền truy cập:")}</div>
          <div>{renderAccess(questionDetail?.access || "")}</div>
        </div>
      </div>
    );
  };

  const checkInfo = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Nội dung gửi duyệt:", "Nội dung gửi duyệt:")}</div>
          {dataDetail?.typeApproved || dataDetail?.action ? (
            <div>{t(dataDetail?.typeApproved || dataDetail?.action, dataDetail?.typeApproved || dataDetail?.action)}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Ngày gửi duyệt:", "Ngày gửi duyệt:")}</div>
          {dataDetail?.approvedSendDate || dataDetail?.createdDate ? (
            <div>
              {dayjs(dataDetail?.approvedSendDate)
                .utc()
                .format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Nội dung duyệt:", "Nội dung duyệt:")}</div>
          {dataDetail?.approvedDescription || questionDetail?.contentApprove ? (
            <div>
              {dataDetail?.approvedDescription ||
                questionDetail?.contentApprove}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Người duyệt:", "Người duyệt:")}</div>
          {dataDetail?.approveByName || dataDetail?.createdBy ? (
            <div>{dataDetail?.approveByName || dataDetail?.createdBy}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Ngày duyệt:", "Ngày duyệt:")}</div>
          {dataDetail?.approvedDate ? (
            <div>
              {moment(dataDetail?.approvedDate).format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
      </div>
    );
  };

  const checkInfoQuestion = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Nội dung gửi duyệt:", "Nội dung gửi duyệt:")}</div>
          {questionDetail?.typeApproved || questionDetail?.action ? (
            <div>{t(questionDetail?.typeApproved || questionDetail?.action, questionDetail?.typeApproved || questionDetail?.action)}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Ngày gửi duyệt:", "Ngày gửi duyệt:")}</div>
          {questionDetail?.approvedSendDate || questionDetail?.createdDate ? (
            <div>
              {dayjs(
                questionDetail?.approvedSendDate || questionDetail?.createdDate
              )
                .utc()
                .format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">
              {t("Chưa có thông tin", "Chưa có thông tin")} {dataDetail?.createdDate}{" "}
            </div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Nội dung duyệt:", "Nội dung duyệt:")}</div>
          {questionDetail?.approvedDescription ||
            questionDetail?.contentApprove ? (
            <div>
              {questionDetail?.approvedDescription ||
                questionDetail?.contentApprove}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Người duyệt:", "Người duyệt:")}</div>
          {questionDetail?.approveByName || questionDetail?.createdBy ? (
            <div>
              {questionDetail?.approveByName || questionDetail?.createdBy}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Ngày duyệt:", "Ngày duyệt:")}</div>
          {questionDetail?.approvedDate ? (
            <div>
              {moment(questionDetail?.approvedDate).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
      </div>
    );
  };

  const publishInfo = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Ngày xuất bản:", "Ngày xuất bản:")}</div>
          {dataDetail?.publicDate ? (
            <div>
              {dayjs(dataDetail?.publicDate)
                .utc()
                .format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Tình trạng:", "Tình trạng:")}</div>
          {dataDetail?.publishStatus ? (
            <div>{getPublishStatus(dataDetail?.publishStatus)}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
      </div>
    );
  };

  const publishInfoQuestion = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Ngày xuất bản:", "Ngày xuất bản:")}</div>
          {questionDetail?.publicDate ? (
            <div>
              {dayjs(questionDetail?.publicDate)
                .utc()
                .format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Tình trạng:", "Tình trạng:")}</div>
          {questionDetail?.publishStatus ? (
            <div>{getPublishStatus(questionDetail?.publishStatus)}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
      </div>
    );
  };

  const infoApprove = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Ngày gửi:", "Ngày gửi:")}</div>
          {dataDetail?.approvedSendDate ? (
            <div>
              {dayjs(dataDetail?.approvedSendDate)
                .format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Nội dung gửi duyệt:", "Nội dung gửi duyệt:")}</div>
          {dataDetail?.typeApproved || dataDetail?.action ? (
            <div>{dataDetail?.typeApproved || dataDetail?.action}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="">
          <div className="info-title">{t("Nội dung duyệt:", "Nội dung duyệt:")}</div>
          <Radio.Group
            className="radio-approve"
            onChange={onChangeRadio}
            value={approveRadio}
          >
            <Radio value={1}>{t("Duyệt", "Duyệt")}</Radio>
            <Radio value={0}>{t("Không duyệt", "Không duyệt")}</Radio>
          </Radio.Group>
          <TextArea
            placeholder={t("Nhập ý kiến", "Nhập ý kiến")}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
          />
        </div>
      </div>
    );
  };

  const infoApproveQuestion = () => {
    return (
      <div className={`${mode === "4" ? "info" : ""}`}>
        <div className="info-item">
          <div className="info-title">{t("Ngày gửi:", "Ngày gửi:")}</div>
          {questionDetail?.approvedSendDate ? (
            <div>
              {dayjs(questionDetail?.approvedSendDate)
                .format("DD/MM/YYYY HH:mm:ss")}
            </div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="info-item">
          <div className="info-title">{t("Nội dung gửi duyệt:", "Nội dung gửi duyệt:")}</div>
          {questionDetail?.typeApproved || questionDetail?.action ? (
            <div>{questionDetail?.typeApproved || questionDetail?.action}</div>
          ) : (
            <div className="no-info">{t("Chưa có thông tin", "Chưa có thông tin")}</div>
          )}
        </div>
        <div className="">
          <div className="info-title">{t("Nội dung duyệt:", "Nội dung duyệt:")}</div>
          <Radio.Group
            className="radio-approve"
            onChange={onChangeRadio}
            value={approveRadio}
          >
            <Radio value={1}>{t("Duyệt", "Duyệt")}</Radio>
            <Radio value={0}>{t("Không duyệt", "Không duyệt")}</Radio>
          </Radio.Group>
          <TextArea
            placeholder={t("Nhập ý kiến", "Nhập ý kiến")}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
          />
        </div>
      </div>
    );
  };

  const handleChangeSelectDate = (time: any) => {
    setSelectDate(time);
    setHandlePressSave(false);
  };

  const publishSetting = () => {
    return (
      <div>
        <Select
          disabled={approveRadio === 0}
          className="w-full mb-2"
          showSearch
          value={publishMode}
          placeholder={t("Chọn lịch xuất bản", "Chọn lịch xuất bản")}
          optionFilterProp="label"
          onChange={(value) => {
            setHandlePressSave(false);
            setPublishMode(Number(value));
          }}
        // onSearch={onSearch}
        >
          <Select.Option value={1}>{t("Không xuất bản", "Không xuất bản")}</Select.Option>
          <Select.Option value={2}>{t("Xuất bản ngay", "Xuất bản ngay")}</Select.Option>
          <Select.Option value={3}>{t("Hẹn lịch xuất bản", "Hẹn lịch xuất bản")}</Select.Option>
        </Select>
        {handlePressSave ? (
          <Typography className="text-red-500">
            {t("Vui lòng chọn ngày xuất bản", "Vui lòng chọn ngày xuất bản")}
          </Typography>
        ) : (
          <></>
        )}

        <DatePicker
          status={handlePressSave ? "error" : ""}
          // locale={viLocale}
          showTime={{ format: "HH:mm:ss" }}
          value={selectDate ? selectDate : null}
          disabled={publishMode !== 3}
          format={"DD/MM/YYYY HH:mm:ss"}
          className="w-full"
          placeholder={t("Chọn ngày xuất bản", "Chọn ngày xuất bản")}
          onChange={handleChangeSelectDate}
        />
      </div>
    );
  };

  const detailTab = [
    {
      title: t("Thông tin đề", "Thông tin đề"),
      content: detailExam(),
    },
    {
      title: t("Thông tin duyệt", "Thông tin duyệt"),
      content: checkInfo(),
    },
    {
      title: t("Lịch xuất bản", "Lịch xuất bản"),
      content: publishInfo(),
    },
  ];

  const approveTab = [
    {
      title: t("Thông tin đề", "Thông tin đề"),
      content: detailExam(),
    },
    {
      title: t("Thông tin duyệt", "Thông tin duyệt"),
      content: infoApprove(),
    },
    {
      title: t("Lịch xuất bản", "Lịch xuất bản"),
      content: publishSetting(),
    },
  ];

  const questionTab = [
    {
      title: t("Thông tin câu hỏi", "Thông tin câu hỏi"),
      content: detailQuestion(),
    },
    {
      title: t("Thông tin duyệt", "Thông tin duyệt"),
      content: checkInfoQuestion(),
    },
    {
      title: t("Lịch xuất bản", "Lịch xuất bản"),
      content: publishInfoQuestion(),
    },
  ];

  const approveQuestion = [
    {
      title: t("Thông tin câu hỏi", "Thông tin câu hỏi"),
      content: detailQuestion(),
    },
    {
      title: t("Thông tin duyệt", "Thông tin duyệt"),
      content: infoApproveQuestion(),
    },
    {
      title: t("Lịch xuất bản", "Lịch xuất bản"),
      content: publishSetting(),
    },
  ];

  const getComponent = (caseValue: string) => {
    switch (caseValue) {
      case "1":
        return (
          <Collapse defaultActiveKey={[0, 1, 2]}>
            {detailTab.map((el, index) => {
              return (
                <Panel key={index} header={el?.title}>
                  <div className="sub-content">{el?.content}</div>
                </Panel>
              );
            })}
          </Collapse>
        );
      case "8":
        return (
          <Collapse defaultActiveKey={[0, 1, 2]}>
            {detailTab.map((el, index) => {
              return (
                <Panel key={index} header={el?.title}>
                  <div className="sub-content">{el?.content}</div>
                </Panel>
              );
            })}
          </Collapse>
        );
      case "2":
        return (
          <Collapse defaultActiveKey={[0, 1, 2]}>
            {approveTab.map((el, index) => {
              return (
                <Panel key={index} header={el?.title}>
                  <div className="sub-content">{el?.content}</div>
                </Panel>
              );
            })}
          </Collapse>
        );
      case "5":
        return (
          <Collapse defaultActiveKey={[0, 1, 2]}>
            {questionTab.map((el, index) => {
              return (
                <Panel key={index} header={el?.title}>
                  <div className="sub-content">{el?.content}</div>
                </Panel>
              );
            })}
          </Collapse>
        );
      case "7":
        return (
          <Collapse defaultActiveKey={[0, 1, 2]}>
            {questionTab.map((el, index) => {
              return (
                <Panel key={index} header={el?.title}>
                  <div className="sub-content">{el?.content}</div>
                </Panel>
              );
            })}
          </Collapse>
        );
      case "6":
        return (
          <Collapse defaultActiveKey={[0, 1, 2]}>
            {approveQuestion.map((el, index) => {
              return (
                <Panel key={index} header={el?.title}>
                  <div className="sub-content">{el?.content}</div>
                </Panel>
              );
            })}
          </Collapse>
        );
      default:
        return <div>Default Component</div>;
    }
  };

  return (
    <>
      {mode === "4" ? (
        <></>
      ) : (
        <div className={`setting-exam ${flag ? "" : "tab-closed w-[50px]"}`}>
          <div className="setting-exam__header flex">
            <MenuUnfoldOutlined
              className="setting-exam__header__first"
              rotate={flag ? 0 : 180}
              onClick={toggleFlag}
            />
            <SettingOutlined className="setting-exam__header__second" />
            <div className="setting-exam__header__title">
              {mode === "0" ? t("Thông tin đề", "Thông tin đề") : t("Thông tin duyệt", "Thông tin duyệt")}
            </div>
          </div>
          <div
            className="setting-exam__content"
            style={{ visibility: flag ? "visible" : "hidden" }}
          >
            <div className={`${flag ? "info-container" : "info-container-v2"}`}>
              {mode === "0" ? detailExam() : getComponent(mode)}
            </div>
            {mode === "2" || mode === "6" ? (
              <div className="button-container">
                <Button
                  onClick={() => {
                    handlePopupConfirm();
                  }}
                  className="btn btn-primary width-button-100 ml-2"
                >
                  <CheckOutlined />
                  <Typography.Text>{t("Lưu lại", "Lưu lại")}</Typography.Text>
                </Button>
                <Button onClick={navigateBack} className="btn width-button-100">
                  <CloseOutlined />
                  <Typography.Text>{t("Hủy bỏ", "Hủy bỏ")}</Typography.Text>
                </Button>
              </div>
            ) : (
              <></>
            )}

            <Modal
              title={t("Xác nhận", "Xác nhận")}
              open={isVisibleConfirm}
              onOk={handleConfirm}
              onCancel={() => {
                setIsVisibleConfirm(false);
              }}
              className="h-56"
              centered
              footer={[
                <div className="flex flex-row items-center w-full justify-evenly">
                  <Button
                    key="cancel"
                    icon={<CloseOutlined />}
                    onClick={() => {
                      setIsVisibleConfirm(false);
                    }}
                  >
                    {t("Hủy bỏ", "Hủy bỏ")}
                  </Button>
                  <Button
                    key="ok"
                    icon={<CheckOutlined />}
                    type="primary"
                    onClick={handleConfirm}
                  >
                    {t("Xác nhận", "Xác nhận")}
                  </Button>
                </div>,
              ]}
            >
              <div className="text-center h-20 flex flex-col justify-evenly">
                <p>{t("Bạn chắc chắn muốn lưu lại nội dung kiểm duyệt?", "Bạn chắc chắn muốn lưu lại nội dung kiểm duyệt?")}</p>
                {dataDetail?.access !== "Nội bộ" &&
                  dataDetail?.access !== "Giới hạn" &&
                  questionDetail?.access !== "Nội bộ" &&
                  questionDetail?.access !== "Giới hạn" && (
                    <p style={{ color: "red", fontStyle: "italic" }}>
                      {t("Nội dung sẽ được gửi lên cấp Bộ sau khi duyệt.", "Nội dung sẽ được gửi lên cấp Bộ sau khi duyệt.")}
                    </p>
                  )}
              </div>
            </Modal>
          </div>
        </div>
      )}
    </>
  );
};

export default SettingExam;
